import { supabase } from "../supabaseClient";

async function createBucketInDrive() {
  let query = supabase.storage.createBucket("", {
    public: false,
    fileSizeLimit: 1024,
  });
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function retriveBucketInDrive(path) {
  const { data, error } = await supabase.storage.getBucket(path);
  if (data) return { data };
  else throw error;
}

async function deleteBucketInDrive() {
  const { data, error } = await supabase.storage.deleteBucket("avatars");
  if (data) return { data };
  else throw error;
}

async function UploadFile(file, id) {
  let query = supabase.storage
    .from("projectcollaterals")
    .upload(`${id}/${file.name}`, file);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function createFolderInDrive(path) {
  let query = await supabase.storage
    .from("projectcollaterals")
    .upload(`${path}/.emptyFolderPlaceholder`, "");
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function downloadFile(fileName) {
  const { data, error } = await supabase.storage
    .from("projectcollaterals")
    .download(fileName);
  if (data) return { data };
  else throw error;
}
async function downloadPreviewAggrementConfirmationDocFile(fileName) {
  const { data, error } = await supabase.storage
    .from("AgreementKYCDocuments")
    .download(fileName);
  if (data) return { data };
  else throw error;
}

async function listAllFileOfBucket(folderName) {
  const { data, error } = await supabase.storage
    .from("projectcollaterals")
    .list(`${folderName}`, {
      limit: 100,
      offset: 0,
      sortBy: { column: "name", order: "asc" },
    });
  if (data) return { data };
  else throw error;
}

async function deleteFileFromStorage(fileName) {
  const { data, error } = await supabase.storage
    .from("projectcollaterals")
    .remove([fileName]);
  if (data) return data;
  else throw error;
}

async function removeFileFromTable(fileName) {
  let query = supabase
    .from("ProjectCollaterals")
    .delete()
    .eq("fileName", fileName);
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

export {
  UploadFile,
  deleteFileFromStorage,
  createBucketInDrive,
  retriveBucketInDrive,
  deleteBucketInDrive,
  downloadFile,
  listAllFileOfBucket,
  createFolderInDrive,
  removeFileFromTable,
  downloadPreviewAggrementConfirmationDocFile
};
